export const pinLoginEnglish = {
  lang: 'en',
  data: {
    PIN: {
      MESSAGE: 'Support Panel',
      SUBMIT: 'E-mail',
      PASSWORD: 'Password',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/2fa/i18n/en.ts